
// import { useState } from 'react';



// const StrikethroughTextConverter = () => {
//   const [text, setText] = useState('');
//   const [formatting, setFormatting] = useState({
//     isItalic: false,
//     isStrikethrough: false,
//   });



//   const handleTextChange = (e) => {
//     setText(e.target.value);
//   };

//   const toggleCase = () => {
//     const toggledText = text
//       .split('')
//       .map((char) =>
//         char === char.toUpperCase() ? char.toLowerCase() : char.toUpperCase()
//       )
//       .join('');
//     setText(toggledText);
//   };

//   const [copyButtonLabel, setCopyButtonLabel] = useState('Copy Text'); // State for button label

//   const copyToClipboard = () => {
//     navigator.clipboard.writeText(text);
//     setCopyButtonLabel('Copied!'); // Update button label to "Copied!"
//     setTimeout(() => setCopyButtonLabel('Copy Text'), 1500); // Revert back to "Copy Number" after 1.5 seconds
//   };

//   const toggleFormat = (format) => {
//     setFormatting((prev) => ({
//       ...prev,
//       [format]: !prev[format],
//     }));
//   };

//   const getTextStyle = () => {
//     return {
//       fontStyle: formatting.isItalic ? 'italic' : 'normal',
//       textDecoration: formatting.isStrikethrough ? 'line-through' : 'none',
//     };
//   };


//      // Function to calculate text statistics
//      const calculateTextStats = (text) => {
//       const totalCharacters = text.length;
//       const totalCharactersWithoutSpace = text.replace(/\s+/g, '').length;
//       const totalWords = text.trim() === '' ? 0 : text.trim().split(/\s+/).length;
//       const totalParagraphs = text.split(/\n+/).filter(Boolean).length;
//       const totalSentences = text.split(/[.!?]+/).filter(Boolean).length;
  
//       return {
//         totalCharacters,
//         totalCharactersWithoutSpace,
//         totalWords,
//         totalParagraphs,
//         totalSentences,
//       };
//     };
  
//       // Calculate stats dynamically based on current binary value
//   const stats = calculateTextStats(text);

//   return (
//     <div className="container mt-5 p-4 bg-white rounded shadow-md max-w-lg mx-auto">
//       {/* Text Area */}
//       <textarea
//         className="w-full p-2 border rounded mb-4"
//         value={text}
//         onChange={handleTextChange}
//         rows={8}
//         style={getTextStyle()} // Apply the styles dynamically
//         placeholder="Enter your text here..."
//       />
      
//       {/* Formatting Options */}
//       <div className="d-flex  align-items-center mb-3">
        
//         <button
//           className={`btn ${formatting.isStrikethrough ? 'btn-primary' : 'btn-outline-secondary'}`}
//           onClick={() => toggleFormat('isStrikethrough')}
//         >
//           Strike Through
//         </button>
//         <button
//           className={`btn ${formatting.isItalic ? 'btn-primary' : 'btn-outline-secondary'}`}
//           onClick={() => toggleFormat('isItalic')}
//         >
//        Italic
//         </button>
//         <button className="btn btn-primary" onClick={copyToClipboard}>
//         {copyButtonLabel}
//         </button>
//       </div>

//       <div className="mt-3 text-muted">
//             <p>
//               Total Characters with Space: {stats.totalCharacters} | Total Characters without Space: {stats.totalCharactersWithoutSpace} | Total Words: {stats.totalWords}</p>
//             <p>
//                Total Paragraphs: {stats.totalParagraphs} | Total Sentences: {stats.totalSentences}
//             </p>
//           </div>
//     </div>
//   );
// };

// export default StrikethroughTextConverter;


import { useState } from 'react';

const StrikethroughTextConverter = () => {
  const [text, setText] = useState('');
  const [formatting, setFormatting] = useState({
    // isItalic: false,
    isStrikethrough: false,
  });

  // Unicode mapping for italic and strikethrough characters
  const unicodeMap = {
    // italic: {
    //   'a': '𝘢', 'b': '𝘣', 'c': '𝘤', 'd': '𝘥', 'e': '𝘦',
    //   'f': '𝘧', 'g': '𝘨', 'h': '𝘩', 'i': '𝘪', 'j': '𝘫',
    //   'k': '𝘬', 'l': '𝘭', 'm': '𝘮', 'n': '𝘯', 'o': '𝘰',
    //   'p': '𝘱', 'q': '𝘲', 'r': '𝘳', 's': '𝘴', 't': '𝘵',
    //   'u': '𝘶', 'v': '𝘷', 'w': '𝘸', 'x': '𝘹', 'y': '𝘺',
    //   'z': '𝘻',
    //   'A': '𝘈', 'B': '𝘉', 'C': '𝘊', 'D': '𝘋', 'E': '𝘌',
    //   'F': '𝘍', 'G': '𝘎', 'H': '𝘏', 'I': '𝘐', 'J': '𝘑',
    //   'K': '𝘒', 'L': '𝘓', 'M': '𝘔', 'N': '𝘕', 'O': '𝘖',
    //   'P': '𝘗', 'Q': '𝘘', 'R': '𝘙', 'S': '𝘚', 'T': '𝘛',
    //   'U': '𝘜', 'V': '𝘝', 'W': '𝘞', 'X': '𝘟', 'Y': '𝘠',
    //   'Z': '𝘡'
    // },
    strikethrough: {
      'a': 'a̶', 'b': 'b̶', 'c': 'c̶', 'd': 'd̶', 'e': 'e̶',
      'f': 'f̶', 'g': 'g̶', 'h': 'h̶', 'i': 'i̶', 'j': 'j̶',
      'k': 'k̶', 'l': 'l̶', 'm': 'm̶', 'n': 'n̶', 'o': 'o̶',
      'p': 'p̶', 'q': 'q̶', 'r': 'r̶', 's': 's̶', 't': 't̶',
      'u': 'u̶', 'v': 'v̶', 'w': 'w̶', 'x': 'x̶', 'y': 'y̶',
      'z': 'z̶',
      'A': 'A̶', 'B': 'B̶', 'C': 'C̶', 'D': 'D̶', 'E': 'E̶',
      'F': 'F̶', 'G': 'G̶', 'H': 'H̶', 'I': 'I̶', 'J': 'J̶',
      'K': 'K̶', 'L': 'L̶', 'M': 'M̶', 'N': 'N̶', 'O': 'O̶',
      'P': 'P̶', 'Q': 'Q̶', 'R': 'R̶', 'S': 'S̶', 'T': 'T̶',
      'U': 'U̶', 'V': 'V̶', 'W': 'W̶', 'X': 'X̶', 'Y': 'Y̶',
      'Z': 'Z̶'
    },
    // italicStrikethrough: {
    //   'a': '𝘢̶', 'b': '𝘣̶', 'c': '𝘤̶', 'd': '𝘥̶', 'e': '𝘦̶',
    //   'f': '𝘧̶', 'g': '𝘨̶', 'h': '𝘩̶', 'i': '𝘪̶', 'j': '𝘫̶',
    //   'k': '𝘬̶', 'l': '𝘭̶', 'm': '𝘮̶', 'n': '𝘯̶', 'o': '𝘰̶',
    //   'p': '𝘱̶', 'q': '𝘲̶', 'r': '𝘳̶', 's': '𝘴̶', 't': '𝘵̶',
    //   'u': '𝘶̶', 'v': '𝘷̶', 'w': '𝘸̶', 'x': '𝘹̶', 'y': '𝘺̶',
    //   'z': '𝘻̶',
    //   'A': '𝘈̶', 'B': '𝘉̶', 'C': '𝘊̶', 'D': '𝘋̶', 'E': '𝘌̶',
    //   'F': '𝘍̶', 'G': '𝘎̶', 'H': '𝘏̶', 'I': '𝘐̶', 'J': '𝘑̶',
    //   'K': '𝘒̶', 'L': '𝘓̶', 'M': '𝘔̶', 'N': '𝘕̶', 'O': '𝘖̶',
    //   'P': '𝘗̶', 'Q': '𝘘̶', 'R': '𝘙̶', 'S': '𝘚̶', 'T': '𝘛̶',
    //   'U': '𝘜̶', 'V': '𝘝̶', 'W': '𝘞̶', 'X': '𝘟̶', 'Y': '𝘠̶',
    //   'Z': '𝘡̶'
    // }
  };

  const handleTextChange = (e) => {
    setText(e.target.value);
  };

  const handleClear = () => {
    setText('');
    setFormatting({
      // isItalic: false,
      isStrikethrough: false,
    });
  };

  const [copyButtonLabel, setCopyButtonLabel] = useState('Copy Text');

  const convertText = (input) => {
    // if (formatting.isItalic && formatting.isStrikethrough) {
    //   return input.split('').map(char => unicodeMap.italicStrikethrough[char] || char).join('');
    // }
    // if (formatting.isItalic) {
    //   return input.split('').map(char => unicodeMap.italic[char] || char).join('');
    // }
    if (formatting.isStrikethrough) {
      return input.split('').map(char => unicodeMap.strikethrough[char] || char).join('');
    }
    return input;
  };

  const copyToClipboard = () => {
    const textToCopy = convertText(text);
    navigator.clipboard.writeText(textToCopy);
    setCopyButtonLabel('Copied!');
    setTimeout(() => setCopyButtonLabel('Copy Text'), 1500);
  };

  const toggleFormat = (format) => {
    setFormatting((prev) => ({
      ...prev,
      [format]: !prev[format],
    }));
  };

  const calculateTextStats = (text) => {
    const totalCharacters = text.length;
    const totalCharactersWithoutSpace = text.replace(/\s+/g, '').length;
    const totalWords = text.trim() === '' ? 0 : text.trim().split(/\s+/).length;
    const totalParagraphs = text.split(/\n+/).filter(Boolean).length;
    const totalSentences = text.split(/[.!?]+/).filter(Boolean).length;

    return {
      totalCharacters,
      totalCharactersWithoutSpace,
      totalWords,
      totalParagraphs,
      totalSentences,
    };
  };

  const stats = calculateTextStats(text);
  const convertedText = convertText(text);

  return (
    <div className="container mt-5 p-4 bg-white rounded shadow-md max-w-lg mx-auto">
      <textarea
        className="w-full p-2 border rounded mb-4"
        value={text}
        onChange={handleTextChange}
        rows={8}
        placeholder="Enter your text here..."
      />

      <div className="d-flex align-items-center mb-3">
        {/* <button
          className={`btn ${formatting.isItalic ? 'btn-primary' : 'btn-outline-secondary'}`}
          onClick={() => toggleFormat('isItalic')}
        >
          Italic
        </button> */}

        <button
          className={`btn ${formatting.isStrikethrough ? 'btn-primary' : 'btn-outline-secondary'}`}
          onClick={() => toggleFormat('isStrikethrough')}
        >
          Strikethrough
        </button>

        <button className="btn btn-primary" onClick={copyToClipboard}>
          {copyButtonLabel}
        </button>
        <button className="btn btn-danger" onClick={handleClear}>
          Clear
        </button>
      </div>

      {convertedText !== text && (
        <div className="mt-3 bg-gray-100 p-3 rounded">
          <strong>Converted Text:</strong>
          <textarea
            className="form-control mb-4"
            style={{ height: '10rem' }}
            value={convertedText}
            readOnly
            rows={10}
          />
        </div>
      )}

      <div className="mt-3 text-muted">
        <p>
          Total Characters with Space: {stats.totalCharacters} | Total Characters without Space: {stats.totalCharactersWithoutSpace} | Total Words: {stats.totalWords}
        </p>
        <p>
          Total Paragraphs: {stats.totalParagraphs} | Total Sentences: {stats.totalSentences}
        </p>
      </div>
    </div>
  );
};

export default StrikethroughTextConverter;